
export default {
  //获取签到记录详情
  getFaceInRecordDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/csface-server/business/getFaceInRecordDetail',
      params: params,
    });
  },
  // 充值(支付生成订单)
  buildOrder(params) {
    return app.http.ajax({
      method: 'post',
      url: '/csface-server/payment/buildOrder',
      params: params,
    });
  },
  // 获取学员充值明细
  getTransactionByParent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/csface-server/wallet/getTransactionByParent',
      params: params,
    });
  },
  // 获取公众号首页信息
  getGzhHome(params) {
    return app.http.ajax({
      method: 'post',
      url: '/csface-server/business/getGzhHome',
      params: params,
    });
  },
  //获取家长信息(包含绑定学员列表)
  getParentsInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/csface-server/parent/getParentsInfo',
      params: params,
    });
  },
  // 获取学员权益信息
  getRights(params) {
    return app.http.ajax({
      method: 'get',
      url: '/csface-server/student/getRights',
      params: params,
    });
  },
  // 获取支付金额列表-公众号H5调用
  getChargeDurations(params) {
    return app.http.ajax({
      method: 'get',
      url: '/csface-server/payment/getChargeDurations',
      params: params,
    });
  },
  //获取家长信息(指定机构的，因为家长端是私域)(包含绑定学员列表)
  getParentsInfoByCompany(params) {
    return app.http.ajax({
      method: 'get',
      url: '/csface-server/parent/getParentsInfoByCompany',
      params: params,
    });
  },
  // 获取学员详情（含人脸版）
  getStudentFace(params) {
    return app.http.ajax({
      method: 'get',
      url: '/csface-server/student/get',
      params: params,
    });
  },
  // 更新学员信息
  updateFaceStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: `/csface-server/student/update`,
      params: params,
    });
  },
};
